import React, { useEffect, useState } from "react";
import "./EttiksoftChroniclesStyles/EttiksoftChronicles.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import ParagraphAnimation from "../../components/TextAnimation/ParagraphAnimation";

// ✅ Default fallback data
const defaultChroniclesData = [
  {
    image: require("../../assets/images/engineers-working-digital-car-design-hightech-automotive-factory.png"),
    place: "Namakkal Office",
    date: "02 – January – 2025",
    description:
      "Our Namakkal Ettiksoft office thrives as a dynamic startup environment, fostering innovation and growth in the heart of a vibrant community.",
  },
  {
    image: require("../../assets/images/side-view-attractive-hispanic-software-developer-programming-using-computer-while-working-from-home.png"),
    place: "Chennai Office",
    date: "15 – February – 2025",
    description:
      "The Chennai branch fosters collaboration and technical excellence with a dynamic, fast-paced culture.",
  }
];

const EttiksoftChronicles = () => {
  const [chronicles, setChronicles] = useState(defaultChroniclesData);

  useEffect(() => {
    const API_URL = "/getChronicles.php";
  
    fetch(API_URL)
      .then(res => res.json())
      .then(data => {
        console.log("✅ API Chronicles Response:", data);
  
        const validChronicles = (data?.value || [])
          .filter(item => item.title && item.date && item.place && item.description)
          .map(item => ({
            place: item.place,
            date: item.date,
            description: item.description,
            image: item.image?.startsWith("http")
  ? item.image
  : `/${item.image}`

          }));
  
        console.log("🟡 Processed Valid Chronicles:", validChronicles);
  
        if (validChronicles.length > 0) {
          setChronicles(validChronicles);
        } else {
          console.warn("⚠️ No valid chronicles found, using fallback.");
        }
      })
      .catch(err => {
        console.error("Chronicles API fetch error:", err);
      });
  }, []);
  
  
  return (
    <div className="ettiksoft-chronicles">
      <div className="fullscreen section light-section">
        <div className="row-container">
          {/* Left */}
          <div className="text-content">
          <div className="section-title">
  <ParagraphAnimation>Ettiksoft Chronicles</ParagraphAnimation>
</div>

            <div className="flex-grow-1 d-flex flex-column justify-content-end">
              <p className="description">
                From collaborative brainstorming sessions to celebratory milestones, the rhythm of
                our workplace resonates with innovation, camaraderie, and the shared commitment to
                shaping a tomorrow defined by groundbreaking achievements.
              </p>
            </div>
          </div>

          {/* Right */}
          <div className="carousel-container">
            <Swiper
              modules={[Autoplay, Pagination]}
              loop={true}
              autoplay={{ delay: 3500, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              speed={1000}
              slidesPerView={1}
            >
              {chronicles.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="carousel-slide">
                    <img src={item.image} alt={item.place} className="office-image img-fluid" />
                    <div className="image-caption">
                      <span className="location">{item.place}</span>
                      <span className="date">{item.date}</span>
                    </div>
                    <p className="sub-description">{item.description}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EttiksoftChronicles;
